import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define a service using a base URL and expected endpoints
export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://onza-api.ibm.kg/api/user/',
    prepareHeaders: (headers, { getState }) => {
      // Получаем токен из Redux state
      const { auth: { auth } } = getState()
      headers.set("Authorization", `Bearer ${auth?.accessToken}`);
      return headers;
    },
  }),
  tagTypes: ["user"],
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: (data) => {
        return {
          url: `userList`,
          params: {
            ...data
          }
        }
      },
      providesTags: ["user"],
    }),
    getUserMessage: builder.query({
      query: () => `client-message`,
      providesTags: ["user"],
    }),
    getUserByEmail: builder.query({
      query: () => `user-by-email`,
      providesTags: ["user"],
    }),
    createUser: builder.mutation({
      query: (data) => {
        return {
          url: "user",
          body: data,
          method: "POST"
        }
      },
      invalidatesTags: ["user"],
    }),
    sendUserWhatsapp: builder.mutation({
      query: (data) => {
        return {
          url: "user-send-whatsapp",
          body: data,
          method: "POST"
        }
      },
      invalidatesTags: ["user"],
    }),
    sendUserExcelWhatsapp: builder.mutation({
      query: (data) => ({
        url: 'set-users',  // Это путь, куда отправляется запрос
        method: 'POST',
        body: data, // Передаем данные (например, файл)
      }),
      invalidatesTags: ['user'], // Это для обновления кеша, если есть такие теги
    }),
    changeUserType: builder.mutation({
      query: (data) => {
        return {
          url: "user-type",
          body: data,
          method: "POST"
        }
      },
      invalidatesTags: ["customer"],
    })
  }),
})

export const { useGetUsersQuery, useGetUserMessageQuery, useCreateUserMutation, useChangeUserTypeMutation, useSendUserWhatsappMutation, useSendUserExcelWhatsappMutation } = userApi